import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from '../services/ApplicationInsightsService';
import { types } from '../actions/jobs';
import { parseJobs } from '../utils/dataParsers';

const initialState = {
  pendingFlag: false,
  pendingInfinityScroll: false,
  error: '',
  pendingSave: false,
  errorSave: '',
  response: null,
  pagination: {
    PageNumber: 1,
    PageSize: 10,
    TotalPages: 0
  },
  recommendedJobs: [],
  counters: {
    AppliedJobs: 0,
    SavedJobs: 0,
    TotalJobs: 0,
    Inquiries: null
  },
  pendingCounters: false,
  jobapplicationv2: null,
  pendingApplyV2: null,
  errorApplyV2: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_JOBS_FULFILLED:
    case types.FETCH_SAVED_JOBS_FULFILLED:
    case types.FETCH_APPLIED_JOBS_FULFILLED:
    case types.FETCH_JOBS_PUBLIC_FULFILLED:
    case types.FETCH_JOBS_PUBLIC:
      return {
        ...state,
        pendingFlag: false,
        error: '',
        response: parseJobs(action.payload?.Data),
        pagination: action.payload?.Pagination
      };
    case types.FETCH_JOBS_PENDING:
    case types.FETCH_SAVED_JOBS_PENDING:
    case types.FETCH_APPLIED_JOBS_PENDING:
    case types.FETCH_RECOMENDED_JOBS_PENDING:
    case types.FETCH_JOBS_PUBLIC_PENDING:
      return { ...state, pendingFlag: true, error: '' };
    case types.FETCH_JOBS_REJECTED:
    case types.FETCH_SAVED_JOBS_REJECTED:
    case types.FETCH_APPLIED_JOBS_REJECTED:
    case types.FETCH_JOBS_PUBLIC_REJECTED:
      appInsights.trackException({
        error: new Error(action.payload.message),
        severityLevel: SeverityLevel.Error
      });
      return { ...state, pendingFlag: false, error: action.payload.message };
    case types.FETCH_NEXT_JOBS_PENDING:
    case types.FETCH_NEXT_SAVED_JOBS_PENDING:
    case types.FETCH_NEXT_APPLIED_JOBS_PENDING:
    case types.FETCH_NEXT_JOBS_PUBLIC_PENDING:
      return {
        ...state,
        pendingInfinityScroll: true
      };
    case types.FETCH_NEXT_JOBS_REJECTED:
    case types.FETCH_NEXT_SAVED_JOBS_REJECTED:
    case types.FETCH_NEXT_APPLIED_JOBS_REJECTED:
    case types.FETCH_NEXT_JOBS_PUBLIC_REJECTED:
      return {
        ...state,
        pendingInfinityScroll: false,
        error: action.payload.message
      };
    case types.FETCH_NEXT_JOBS_FULFILLED:
    case types.FETCH_NEXT_SAVED_JOBS_FULFILLED:
    case types.FETCH_NEXT_APPLIED_JOBS_FULFILLED:
    case types.FETCH_NEXT_JOBS_PUBLIC_FULFILLED:
      return {
        ...state,
        pendingInfinityScroll: false,
        error: '',
        response: [...state.response, ...parseJobs(action.payload.Data)],
        pagination: action.payload?.Pagination
      };
    case types.CHANGE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          PageNumber: action.payload
        }
      };
    case types.FETCH_RECOMENDED_JOBS_FULFILLED:
      return { ...state, recommendedJobs: action.payload.Data || [], pendingFlag: false, error: '' };
    case types.GET_COUNTERS_FULFILLED:
      return { ...state, counters: action.payload.Data, pendingCounters: false };
    case types.GET_COUNTERS_PENDING:
      return { ...state, pendingCounters: true };
    case types.SET_APPLIED_JOB:
      return {
        ...state,
        response: state.response
          ? state.response.map((item) => (item.Id !== action.payload ? item : { ...item, IsApplied: true }))
          : state.response
      };
    case types.APPLY_JOB_V2_PENDING:
      return {
        ...state,
        jobapplicationv2: null,
        pendingApplyV2: true,
        errorApplyV2: false
      };
    case types.APPLY_JOB_V2_REJECTED:
      return {
        ...state,
        jobapplicationv2: null,
        pendingApplyV2: false,
        errorApplyV2: true
      };
    case types.APPLY_JOB_V2_FULFILLED:
      return {
        ...state,
        jobapplicationv2: state.response && action.payload.Data,
        pendingApplyV2: false,
        errorApplyV2: false
      };
    case types.SAVE_JOB_PENDING:
      return { ...state, pendingSave: true, errorSave: '' };
    case types.SAVE_JOB_REJECTED:
      return { ...state, pendingSave: false, errorSave: action.payload.message };
    case types.SAVE_JOB_FULFILLED:
      if (action.payload.addToListImmediately) {
        return {
          ...state,
          pendingSave: false,
          errorSave: '',
          response: state.response && action.payload.Data ? [action.payload.Data, ...state.response] : state.response,
          counters: { ...state.counters, SavedJobs: state.counters.SavedJobs + 1 }
        };
      }
      return {
        ...state,
        pendingSave: false,
        errorSave: '',
        response:
          state.response && action.payload.Data
            ? state.response.map((item) => (item.Id !== action.payload.jobId ? item : { ...item, IsSaved: true }))
            : state.response,
        counters: { ...state.counters, SavedJobs: state.counters.SavedJobs + 1 }
      };
    case types.REMOVE_SAVED_JOB_PENDING:
      return { ...state, pendingSave: true, errorSave: '' };
    case types.REMOVE_SAVED_JOB_REJECTED:
      return { ...state, pendingSave: false, errorSave: action.payload.message };
    case types.REMOVE_SAVED_JOB_FULFILLED:
      return {
        ...state,
        pendingSave: false,
        errorSave: '',
        response: !action.payload.withDeleting
          ? state.response.map((item) => (item.Id !== action.payload.jobId ? item : { ...item, IsSaved: false }))
          : state.response.filter((item) => item.Id !== action.payload.jobId),
        counters: { ...state.counters, SavedJobs: state.counters.SavedJobs - 1 }
      };
    case types.FILTER_JOBS_COUNT_PENDING:
      return {
        ...state,
        pendingFilterCount: true,
        error: '',
        filterCount: {}
      };
    case types.FILTER_JOBS_COUNT_FULFILLED:
      return {
        ...state,
        pendingFilterCount: false,
        error: '',
        filterCount: action.payload?.Data?.filteredJobCount
      };
    case types.GET_SEARCH_SUGGESTION_PENDING:
      return {
        ...state,
        pendingSuggestion: true,
        error: '',
        suggestion: []
      };
    case types.GET_SEARCH_SUGGESTION_FULFILLED:
      return {
        ...state,
        pendingSuggestion: false,
        error: '',
        suggestion: action.payload?.Data
      };
    default:
      return state;
  }
}
